import { Grid2 } from "@mui/material";
import MyLearningWidget from "../widgets/myLearning/MyLearningWidget";
import styles from "../CustomWidgets.module.scss";

const MyLearningGrid = () => (
  <Grid2 container width={"100%"} className={styles.myLearningGridContainer}>
    <Grid2
      size={{ xs: 12 }}
      display="flex"
      justifyContent={"center"}
      ml={{ xs: 2, md: 0 }}
    >
      <MyLearningWidget />
    </Grid2>
  </Grid2>
);

export default MyLearningGrid;
